import { createContext } from "react";

const TodosContext = createContext();

export default TodosContext;